import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import AdminClinicEditBlock from 'components/templates/admin/clinicEdit';
import AdminClinicThresholdEdit from 'components/templates/admin/clinicThresholdEdit';
import useUser from 'utils/useUser';
import { isAdmin, isPractice } from 'utils/userTypeHelper';

const AdminClinicEdit = () => {
  const { userType } = useUser();
  const { clinicGuid } = useParams();
  const {
    adminPanelClinics: {
      getClinic,
      getClinics,
      getAgencies,
      getThreshold,
      getRepresentatives,
    },
  } = useDispatch();
  const iamAdmin = isAdmin(userType);

  useEffect(async () => {
    await getThreshold(clinicGuid);
    if (iamAdmin) await getAgencies();
    if (!isPractice(userType)) await getRepresentatives();
    await getClinic(clinicGuid);
    await getClinics({ items: null, noLimit: true });
  }, []);
  return (
    <Container>
      <AdminHeader />
      <div>
        <AdminClinicEditBlock />
      </div>
      <div>
        <AdminClinicThresholdEdit clinicGuid={clinicGuid} />
      </div>
    </Container>
  );
};

export default AdminClinicEdit;
